import { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);

  return null;
};

export default ExternalRedirect;
